module.exports = __webpack_public_path__ + "static/img/comIcon4.25acb23f.png";